import styled from 'styled-components';

export const GenericErrorLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin: auto;
  padding: 16px;

  img {
    width: 200px;
    height: 200px;
    padding: 20px;
  }

  owc-typography {
    max-width: 200px;
  }
`;
